<template>
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M560.615-253.847 333.847-480.615l226.768-227.153 32.615 32.614-194.154 194.539L593.23-286.462l-32.615 32.615Z"/></svg>
</template>
